import React from "react"
import rightImage from "../../assets/img/campaign1.jpg"
import leftImage from "../../assets/img/campaign2.jpg"
import { useTranslation } from "react-i18next"

function WhoWeAre({ mission }) {
  const { t } = useTranslation()
  return (
    <>
      {mission.section1 && (
        <div
          className="uk-child-width-1-2@s uk-grid-collapse uk-text-center uk-margin-large-bottom"
          uk-grid="true"
          uk-height-match="true"
        >
          <div className="tile bg-red font-white">
            <div className="uk-padding-large">
              <h1 className="font-white">{t("aboutus.whatWeDo")}</h1>
              <p>{t("aboutus.whatWeDoDesc")}</p>
            </div>
          </div>
          <div className="tile uk-tile uk-background-cover uk-padding-remove uk-cover-container">
            <img src={rightImage} alt="campaignimage" uk-cover="true" />
          </div>
          <div className="tile uk-cover-container uk-tile uk-background-cover uk-padding-remove">
            <img src={leftImage} alt="campaignimage" uk-cover="true" />
          </div>
          <div className="tile uk-text-secondary">
            <div className="uk-tile uk-tile-default">
              <h1>{t("aboutus.whoWeAre")}</h1>
              <p>{t("aboutus.whoWeAreDesc")}</p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default WhoWeAre
